<section class="auto-vision">
  <div class="container">
    @if (!auctionItem) {
      <app-vdp-loader></app-vdp-loader>
    }
  </div>
  @if (auctionItem) {
    <div class="container">
      <div class="row pt-4">
        <app-auto-vision-details-header></app-auto-vision-details-header>
      </div>
      <!-- Auto Vision Carousel -->
      <div class="row py-4">
        <div class="col-xl-8 auto-vision__carousel">
          <app-auto-vision-carousel></app-auto-vision-carousel>
        </div>
        <div class="col-xl-4 auto-vision__auction">
          <app-auto-vision-auction-detail></app-auto-vision-auction-detail>
        </div>
      </div>
      @if (isDesktop$ | async; as isDesktop) {
        @if (isDesktop.matches) {
          <!-- Auto Vision Vehicle Details -->
          <div class="row py-4">
            <app-auto-vision-vehicle-details></app-auto-vision-vehicle-details>
          </div>
          <!-- Auto Vision Lib Equipment Accessories -->
          <div class="row py-4">
            <app-auto-vision-equipment-accessories variant="static"></app-auto-vision-equipment-accessories>
          </div>
          <!-- Auto Vision Condition And Disclosures -->
          <div class="row py-4">
            <div class="col-md-8 mb-4 pb-2">
              <app-auto-vision-condition-disclosures></app-auto-vision-condition-disclosures>
            </div>
            <div class="col-md-4">
              <app-auto-vision-seller-location class="mt-4"></app-auto-vision-seller-location>
            </div>
          </div>
        }
        @if (!isDesktop.matches) {
          <accordion [closeOthers]="true">
            <accordion-group panelClass="accordion">
              <button data-track-elem="accordion" data-track-name="Vehicle Details" data-track-trigger="statechange"
                class="btn btn-link btn-block" accordion-heading type="button" data-test-id="app-auto-vision-shell-e-vehicle-details-button">
                <i class="allycon-glyph-caret-down me-2" aria-hidden="true"></i>
                {{ autoVisionShellTranslations.vehicleDetails }}
              </button>
              <app-auto-vision-vehicle-details [showHeading]="false"></app-auto-vision-vehicle-details>
            </accordion-group>
            <accordion-group panelClass="accordion">
              <button data-track-elem="accordion" data-track-name="Equipment and Accessories"
                data-track-trigger="statechange" class="btn btn-link btn-block" accordion-heading type="button" data-test-id="app-auto-vision-shell-e-equipment-accessories-carousel-button">
                <i class="allycon-glyph-caret-down me-2" aria-hidden="true"></i>
                {{ autoVisionShellTranslations.optionsAndAccessories }}
              </button>
              <div class="detail-carousel-container">
                <app-auto-vision-equipment-accessories variant="carousel"></app-auto-vision-equipment-accessories>
              </div>
            </accordion-group>
            <accordion-group panelClass="accordion">
              <button data-track-elem="accordion" data-track-name="Full Description" data-track-trigger="statechange"
                class="btn btn-link btn-block" accordion-heading type="button" data-test-id="app-auto-vision-shell-e-equipment-accessories-long-description-button">
                <i class="allycon-glyph-caret-down me-2" aria-hidden="true"></i>
                {{ autoVisionShellTranslations.fullDescription }}
              </button>
              <div class="detail-carousel-container">
                <app-auto-vision-equipment-accessories
                variant="long-descriptions-mobile"></app-auto-vision-equipment-accessories>
              </div>
            </accordion-group>
            <accordion-group panelClass="accordion">
              <button data-track-elem="accordion" data-track-name="Condition and Disclosures"
                data-track-trigger="statechange" class="btn btn-link btn-block" accordion-heading type="button" data-test-id="app-auto-vision-shell-e-condition-disclosures-button">
                <i class="allycon-glyph-caret-down me-2" aria-hidden="true"></i>
                {{ autoVisionShellTranslations.conditionAndDisclosures }}
              </button>
              <app-auto-vision-condition-disclosures [showHeading]="false"></app-auto-vision-condition-disclosures>
            </accordion-group>
            <accordion-group panelClass="accordion">
              <button data-track-elem="accordion" data-track-name="Seller and Location" data-track-trigger="statechange"
                class="btn btn-link btn-block" accordion-heading type="button" data-test-id="app-auto-vision-shell-e-seller-location-button">
                <i class="allycon-glyph-caret-down me-2" aria-hidden="true"></i>
                {{ autoVisionShellTranslations.sellerAndLocation }}
              </button>
              <app-auto-vision-seller-location [showHeading]="false"></app-auto-vision-seller-location>
            </accordion-group>
          </accordion>
        }
      }
    </div>
  }
</section>
